<template>
  <div
    class="d-flex justify-center mb-2 mx-2"
    :id="
      (details.text.includes('Task was completed by') ||
        details.text.includes('Task was reopened by')) &&
      details.is_log == true
        ? 'chip-green'
        : 'chip-purple'
    "
  >
    <v-chip
      style="width:100% !important;"
      :color="
        details.text.includes('Reminder of due date on') &&
        details.is_log == true
          ? '#e4e4e4'
          : (details.text.includes('Task was completed by') ||
              details.text.includes('Task was reopened by')) &&
            details.is_log == true
          ? '#ddf6ee'
          : '#f6f5fc'
      "
      class="font-italic font-weight-bold justify-center align-center d-flex  px-3"
      :class="[
        !$vuetify.breakpoint.xs
          ? details.text.includes('Reminder of due date on') &&
            details.is_log == true
            ? 'reminder-task-log-color font-size-10'
            : (details.text.includes('Task was completed by') ||
                details.text.includes('Task was reopened by')) &&
              details.is_log == true
            ? 'complete-task-log-color font-size-10'
            : 'dusty-purple-text font-size-10'
          : details.text.includes('Reminder of due date on') &&
            details.is_log == true
          ? 'reminder-task-log-color font-size-8'
          : (details.text.includes('Task was completed by') ||
              details.text.includes('Task was reopened by')) &&
            details.is_log == true
          ? 'complete-task-log-color font-size-8'
          : 'dusty-purple-text font-size-8',
      ]"
      ><span
        v-line-clamp:50="2"
        :style="
          (details.text.includes('Task was completed by') ||
            details.text.includes('Task was reopened by')) &&
          details.is_log == true
            ? ''
            : 'max-width:100% !important;'
        "
        :class="
          $vuetify.breakpoint.xs ? 'justify-center align-center d-flex' : ''
        "
      >
        {{ details.text }} {{ showDate(details.created_at) }}
      </span>
      <v-spacer></v-spacer>
      <!-- Read Recipt Block -->
      <div
        class="d-flex dark-purple-text "
        :class="!$vuetify.breakpoint.xs ? 'ml-8' : 'ml-4'"
        v-if="
          details.read_by.length &&
            details.text.includes('Reminder of due date on') &&
            details.is_log == true
        "
      >
        <v-tooltip
          open-delay="150"
          color="#f3fafb"
          left
          bottom
          v-if="getLoggedInUser.id == details.user.id"
        >
          <template v-slot:activator="{ on }">
            <p
              :class="
                !$vuetify.breakpoint.xs
                  ? 'sent-time-css2 justify-end'
                  : 'sent-time-css-xs justify-end'
              "
              v-on="on"
            >
              Seen By
            </p>
          </template>
          <span v-if="details.read_by.length != ''">
            <div
              class="title-text d-block text-capitalize"
              v-for="(user, index) of details.read_by"
              :key="index"
            >
              {{ user }}
            </div>
          </span>
        </v-tooltip>
      </div>
    </v-chip>
  </div>
</template>

<script>
import moment from "moment";
import { mapGetters } from "vuex";
export default {
  name: "TaskLog",
  props: ["details"],

  computed: {
    ...mapGetters(["getLoggedInUser"]),
  },

  methods: {
    showDate(date) {
      let d = moment(date).format("MMMM Do YYYY, h:mm:ss a");
      return d;
    },
  },
};
</script>

<style scoped>
.complete-task-log-color {
  color: #28806d !important;
}

.reminder-task-log-color {
  color: #474747 !important;
}
.font-size-8 {
  font-size: 8px;
}

.title-text {
  color: cadetblue;
  font-weight: bolder;
  font-size: 11px;
}

#chip-purple .v-chip {
  white-space: unset !important;
  line-height: 12px !important;
}
</style>
